import styled from 'styled-components'

export const TextFieldInput = styled.input`
  padding: 15px 20px;
  font-size: 16px;
  border-radius: 10px;
  width: 100%;
  font-weight: 400;
  outline: none;
  color: ${({ theme }) => theme.colors.primary};
  -webkit-font-smoothing: antialiased;

  background-color: ${({ disabled, theme }) => (disabled ? 'transparent' : theme.colors.backgroundLite)};
  border: ${({ theme }) => `1px solid ${theme.colors.backgroundLite}`};

  &::placeholder {
    color: ${({ theme }) => theme.colors.primary};
  }
`
